<template>
    <vx-selectable v-model="model"
        placeholder="Search Segment"
        :reduce="option => option.value"
        :loading="loading"
        :options="response"
        @search="search"
        data-test="select-segment">
    </vx-selectable>
</template>

<script setup>
import { VxSelectable } from '@voxie/frontend-components';
import { segmentsClient } from '~/services';
import { useSearchRequest } from '~/composables/useSearchRequest';
import { onMounted } from 'vue';

const teamId = Spark.state.currentTeam.id;
const model = defineModel();

const props = defineProps({
    groupId: {
        type: String,
        required: false,
    },
    orgUnitId: {
        type: Number,
        required: false,
    }
});

const {
    loading,
    response,
    createSearch,
    cancelKey,
} = useSearchRequest();

const search = createSearch(async (query) => {
    const params = {
        per_page: 10,
        query: query,
        filter: {
            audience_type: 'transactional',
        },
    };

    if (!props.orgUnitId && !props.groupId) {
        params.filter.is_template = 0;
    }

    const { data } = await segmentsClient.getSegments({ teamId, orgUnitId: props.orgUnitId, groupId: props.groupId }, params, { cancelKey });

    return data.data.map((segment) => ({
        value: segment.id,
        label: `${segment.id} - ${segment.name}`
    }));
});

onMounted(() => {
    search();
});
</script>
